export interface SwitchProps {
  checked: boolean;
  onChange: (v: boolean) => void;
  label?: string;
  hint?: string;
  disabled?: boolean;
  disabledReason?: string;
}

export function Switch({ checked, onChange, label, hint, disabled, disabledReason }: SwitchProps) {
  const track = (
    <span
      role="switch"
      aria-checked={checked}
      aria-label={label}
      tabIndex={disabled ? -1 : 0}
      title={disabled ? disabledReason : undefined}
      onClick={() => !disabled && onChange(!checked)}
      onKeyDown={(e) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
          e.preventDefault();
          onChange(!checked);
        }
      }}
      style={{
        width: 40,
        height: 24,
        borderRadius: 'var(--r-full)',
        flex: 'none',
        background: checked ? 'var(--accent)' : 'var(--bg-2)',
        border: checked ? '1px solid var(--accent)' : '1px solid var(--border)',
        display: 'inline-flex',
        alignItems: 'center',
        padding: 2,
        justifyContent: checked ? 'flex-end' : 'flex-start',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.45 : 1,
        transition: 'background var(--dur-2) var(--ease-spring)',
      }}
    >
      <span
        style={{
          width: 18,
          height: 18,
          borderRadius: '50%',
          background: '#fff',
          boxShadow: 'var(--shadow-1)',
        }}
      />
    </span>
  );

  if (!label) return track;

  return (
    <label
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        cursor: disabled ? 'not-allowed' : 'pointer',
      }}
    >
      <span style={{ flex: 1 }}>
        <span className="t-body" style={{ display: 'block' }}>
          {label}
        </span>
        {hint && (
          <span className="t-caption faint" style={{ display: 'block' }}>
            {hint}
          </span>
        )}
      </span>
      {track}
    </label>
  );
}
